(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["menu-anchor"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('style__tab-content___tu+Kk ul li a').forEach(a => {
    a.addEventListener('click', function (e) {
      console.log(1111)
      e.preventDefault();
      const href = this.getAttribute('href').charAt(0) 
      const targetId = this.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);
      console.log(href)
      if(href != "#"){
        window.open(href, "_blank");
        return false;
      }
      console.log(222)
      this.classList.add('style__active___kA5Y+');
      document.getElementById('navbar').querySelectorAll('.style__tab-content___tu+Kk ul li a').forEach(anchor => {
        anchor.classList.remove('style__active___kA5Y+');
      });
      window.scrollTo({
        top: targetElement.offsetTop - document.getElementById('navbar').querySelector('.style__tab-content___tu+Kk ul').offsetHeight,
        behavior: 'smooth'
      });      
    });
  });

  var navbar = document.getElementById('navbar');
  var navbarOffsetTop = navbar.parentNode.offsetTop;
  document.addEventListener('scroll', function () {
    const scrollPosition = window.scrollY;
    if (scrollPosition >= navbarOffsetTop) {
      navbar.classList.add('fixed');
    } else {
      navbar.classList.remove('fixed');
    }
    document.querySelectorAll('.section-anchor').forEach(section => {
      const sectionTop = section.parentNode.offsetTop - document.getElementById('navbar').offsetHeight;
      const sectionBottom = sectionTop + section.clientHeight;
      if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
        document.getElementById('navbar').querySelectorAll('ul li a').forEach(anchor => {
          anchor.classList.remove('style__active___kA5Y+');
        });
        const correspondingNavLink = document.getElementById('navbar').querySelector(`ul li a[href="#${section.id}"]`);
        if (correspondingNavLink) {
          correspondingNavLink.classList.add('style__active___kA5Y+');
        }
      }
    });
    
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    

   var mySwiper = new Swiper('.mySwiper', {
      pagination: {
        el: '.swiper-pagination',
      },
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solutionFinder"] && !Shopify.designMode) return;
  try {
    
     var pages = document.querySelectorAll(".step");
     var form = document.querySelector("form");
     var pageStack = [];
     var firstPageID;
     var firstPage;


     $(document).ready(function() {
     	setupIntroPage();
     	setupNumShowerSizePage();
     	setupNumFaucetsPage();
     	setupFuelTypePage();
     	setupRVDoorsPage();
     	setupPerformancePage();
     	setupStatePage();
     	setupEmailPage();

     	firstPageID = "intro";
     	firstPage = getPageById(firstPageID);
     	pageStack.push(firstPageID);
     	showPage(firstPage);

       monitorForm();

     })





     function hideAllOtherPages() {
     	pages.forEach(function(page) {
     		page.classList.add("hidden");
     	});
     }

     function getPageById(id) {
     	return Array.from(pages).find(function(page) {
     		return page.id === id;
     	});
     }

     function showPage(page) {
     	hideAllOtherPages();
     	page.classList.remove("hidden");
     }

     function showPreviousPage() {
     	pageStack.pop();
     	var page = getPageById(pageStack[pageStack.length - 1]);
     	showPage(page);
     	page.focus();
     }

     function showNextPage(id) {
     	pageStack.push(id);
     	var page = getPageById(id);
     	showPage(page);
     	page.focus();
     }

     function getSelectedRadioButton(page, name) {
     	var radios = page.querySelectorAll("input[type='radio'][data-name='" + name + "']");
     	return Array.from(radios).find(function(radio) {
     		return radio.checked;
     	});
     }

     function radioButtonsAllowContinue(page, name) {
     	var nextButton = page.querySelector(".next-button");
     	var radioButtons = page.querySelectorAll("input[type='radio'");

     	var clickFn = function() {
     		var selected = getSelectedRadioButton(page, name);
     		if (selected) {
     			nextButton.removeAttribute("disabled");
     		} else {
     			nextButton.setAttribute("disabled", true);
     		}
     	};

     	clickFn();

     	radioButtons.forEach(function(radioButton) {
     		radioButton.addEventListener("click", clickFn);
     	});
     }

     function selectAllowContinue(page, name) {
     	var nextButton = page.querySelector(".next-button");
     	var select = page.querySelector("select[data-name='" + name + "']");

     	var changeFn = function() {
     		var selected = select.value;
     		if (selected !== "") {
     			nextButton.removeAttribute("disabled");
     		} else {
     			nextButton.setAttribute("disabled", true);
     		}
     	};

     	changeFn();

     	select.addEventListener("change", changeFn);
     }

     function applyClassToNonEmptyTextField(field) {
     	var contentClass = "has-content";
     	var toggleClass = function() {
     		if (field.value !== "") {
     			field.classList.add(contentClass);
     		} else {
     			field.classList.remove(contentClass);
     		}
     	};
     	field.addEventListener("keyup", toggleClass);
     	field.addEventListener("change", toggleClass);
     }

     /* Bind the previous and next buttons using nextCB to return the ID of the next slide to show */
     function setupControls(page, nextCB) {
     	var previous = page.querySelector(".back-button");
     	var next = page.querySelector(".next-button");

     	if (previous) {
     		previous.addEventListener("click", showPreviousPage);
     	}

     	if (next) {
     		next.addEventListener("click", function() {
     			showNextPage(nextCB(page));
     		});
     	}
     }

     function setupIntroPage() {
     	var page = pages.item(0);
     	setupControls(page, function() {
     		return "question-1";
     	});
     }

     function setupNumShowerSizePage() {
     	var page = pages.item(1);
     	setupControls(page, function() {
     		return "question-2";
     	});
     	radioButtonsAllowContinue(page, "qtysize_showerhead");
     }

     function setupNumFaucetsPage() {
     	var page = pages.item(2);
     	setupControls(page, function() {
     		return "question-3";
     	});
     	radioButtonsAllowContinue(page, "number_faucets");
     }

     function setupFuelTypePage() {
     	var page = pages.item(3);
     	setupControls(page, function() {
     		return "question-4";
     	});
     	radioButtonsAllowContinue(page, "fuel_type");
     }

     function setupRVDoorsPage() {
     	var page = pages.item(4);
     	setupControls(page, function() {
     		return "question-5";
     	});
     	radioButtonsAllowContinue(page, "door_size");
     }

     function setupPerformancePage() {
     	var page = pages.item(5);
     	setupControls(page, function() {
     		return "question-6";
     	});
     	radioButtonsAllowContinue(page, "heater_performance");
     }

     function setupStatePage() {
     	var page = pages.item(6);
     	setupControls(page, function() {
     		return "question-7";
     	});
     	var select = document.querySelector(".solution-question__dropdown");

       easydropdown(select);
     	selectAllowContinue(page, "state");
     }

     function setupEmailPage() {
     	var page = pages.item(7);
     	var previous = page.querySelector(".back-button");
     	var emailField = page.querySelector("#question-7-1");
     	var submitBtn = document.querySelector("#question-7-controls .next-button");
     	// applyClassToNonEmptyTextField(emailField);
     	//submitBtn.addEventListener("click", function() {
     		//$(this).prop('disabled', true).css('cursor', 'progress');
     		//$('body').css('cursor', 'progress');
     		//recommendProgram();

     		// handleAjaxSubmit();
     	//});
     	if (previous) {
     		previous.addEventListener("click", showPreviousPage);
     	}
     }


     function recommendProgram() {
     	var showerHeadQtySize = $("input[data-name='qtysize_showerhead']:checked").val();
     	var faucetQuantity = $("input[data-name='number_faucets']:checked").val();
     	var state = $("#question-6-1").val();

     	// Calculate the total flow rate of the shower heads and faucets
     	var totalFlowRate = showerHeadQtySize * 1 + 1.2 * faucetQuantity;
       console.log(showerHeadQtySize) //花洒量
       console.log(faucetQuantity) //水龙头数量
       console.log(totalFlowRate); //总流量

     	// Get the maximum flow rate of our water heaters
     	var maxFlowRates = {
     		"AL": [70, 1.8, 2.1, 2.5],
     		"AK": [45, 1.1, 1.3, 1.5],
     		"AZ": [70, 1.8, 2.1, 2.5],
     		"AR": [65, 1.6, 1.9, 2.2],
     		"CA": [60, 1.5, 1.7, 2],
     		"CO": [55, 1.3, 1.6, 1.8],
     		"CT": [50, 1.2, 1.4, 1.6],
     		"DE": [55, 1.3, 1.6, 1.8],
     		"FL": [75, 2.1, 2.5, 2.8],
     		"GA": [70, 1.8, 2.1, 2.5],
     		"HI": [80, 2.5, 2.9, 3.3],
     		"ID": [50, 1.2, 1.4, 1.6],
     		"IL": [50, 1.2, 1.4, 1.6],
     		"IN": [55, 1.3, 1.6, 1.8],
     		"IA": [50, 1.2, 1.4, 1.6],
     		"KS": [55, 1.3, 1.6, 1.8],
     		"KY": [65, 1.6, 1.9, 2.2],
     		"LA": [75, 2.1, 2.5, 2.8],
     		"ME": [45, 1.1, 1.3, 1.5],
     		"MD": [55, 1.3, 1.6, 1.8],
     		"MA": [50, 1.2, 1.4, 1.6],
     		"MI": [45, 1.1, 1.3, 1.5],
     		"MN": [45, 1.1, 1.3, 1.5],
     		"MS": [70, 1.8, 2.1, 2.5],
     		"MO": [60, 1.5, 1.7, 2],
     		"MT": [45, 1.1, 1.3, 1.5],
     		"NE": [55, 1.3, 1.6, 1.8],
     		"NV": [65, 1.6, 1.9, 2.2],
     		"NH": [45, 1.1, 1.3, 1.5],
     		"NJ": [55, 1.3, 1.6, 1.8],
     		"NM": [60, 1.5, 1.7, 2],
     		"NY": [50, 1.2, 1.4, 1.6],
     		"NC": [65, 1.6, 1.9, 2.2],
     		"ND": [45, 1.1, 1.3, 1.5],
     		"OH": [55, 1.3, 1.6, 1.8],
     		"OK": [70, 1.8, 2.1, 2.5],
     		"OR": [50, 1.2, 1.4, 1.6],
     		"PA": [55, 1.3, 1.6, 1.8],
     		"RI": [50, 1.2, 1.4, 1.6],
     		"SC": [70, 1.8, 2.1, 2.5],
     		"SD": [50, 1.2, 1.4, 1.6],
     		"TN": [65, 1.6, 1.9, 2.2],
     		"TX": [70, 1.8, 2.1, 2.5],
     		"UT": [60, 1.5, 1.7, 2],
     		"VT": [45, 1.1, 1.3, 1.5],
     		"VA": [65, 1.6, 1.9, 2.2],
     		"WA": [50, 1.2, 1.4, 1.6],
     		"WV": [65, 1.6, 1.9, 2.2],
     		"WI": [45, 1.1, 1.3, 1.5],
     		"WY": [50, 1.2, 1.4, 1.6]

     	};

     	// Determine the recommended water heater size
     	var custSelcShower = "1Pc 1.5GPM Shower Head";
     	if (showerHeadQtySize == 2) {
     		var custSelcShower = "1Pc 1.8GPM Shower Head";
     	}
     	var custSelcFaucet = "1Pc Faucet";
     	if (faucetQuantity == 2) {
     		var custSelcFaucet = "2Pc Faucets";
     	}
     	var custSelcFuel = $("input[data-name='fuel_type']:checked").val();

     	var custSelcDoorSize = "15inch×15inch";
     	var rvDoorSize = $("input[data-name='door_size']:checked").val();
     	if (rvDoorSize == "15-18") {
     		var custSelcFaucet = "15inch×18inch";
     	} else {
     		var custSelcFaucet = "18inch×18inch";
     	}

       
     	var heaterPerformance = $("input[data-name='heater_performance']:checked").val();
     	var recommendedWaterHeaterSize = "";
        var GPM = "";
        var abolish = false;//不推荐指定产品
        if(totalFlowRate < maxFlowRates[state][1] && abolish){
            GPM = maxFlowRates[state][1]
            recommendedWaterHeaterSize = "InstaShower 6"; 
        }else if(totalFlowRate < maxFlowRates[state][2] ){
            GPM = maxFlowRates[state][2]
            recommendedWaterHeaterSize = "InstaShower 7"; 
        }else{
            GPM = maxFlowRates[state][3]
            recommendedWaterHeaterSize = "InstaShower 8 Plus";  
        }
        
     	if(heaterPerformance == "buffered"){
            GPM = maxFlowRates[state][3];
        	recommendedWaterHeaterSize = "InstaShower 9 Pro";
        }
        $("#GPM").val(GPM);
        var recommendedWaterHeaterClassName = recommendedWaterHeaterSize.replaceAll(" ", "");
        var recommendedWaterHeaterSizeDom = document.getElementsByClassName(recommendedWaterHeaterClassName);
        //var GPM = document.querySelector("." + recommendedWaterHeaterClassName + " .product-details__supplementary").innerText;

        $("#recommendedModel").val(recommendedWaterHeaterSize);
        $("#totalFlowRate").val(totalFlowRate);
        $("#waterInletTemperature").val(maxFlowRates[state][0]);
       
        
        document.getElementsByClassName("solution-selector-result")[0].classList.remove("hidden")
        recommendedWaterHeaterSizeDom[0].classList.remove("hidden");

        document.getElementsByClassName("solution-selector-questions")[0].classList.add("hidden")


    //alert(recommendedWaterHeaterSize)

     }

    function getFormData(fromId) {
  		var form = document.getElementById(fromId);
  		var formData = {};
  		for (var i = 0; i < form.elements.length; i++) {
  			var element = form.elements[i];
  			if (element.tagName === "INPUT" || element.tagName === "SELECT") {
  				if ((element.type === "text" || element.type === "email") || (element.checked  && element.type === "radio")) {
  					formData[element.dataset.name] =  element.value;
  				} else if (element.tagName === "SELECT") {
  					formData[element.dataset.name] = element.options[element.selectedIndex].value;
  				}
  			}
  		}
  		return formData;
  	}



  function monitorForm(){
    $('#form__solution-selector').submit(function(event) {
     // event.preventDefault();
      
      $("#form__solution-selector").attr("target", "form__solution-selector-iFrame");
      var monitorData = getFormData("form__solution-selector");
      var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      console.log(monitorData);
      
      /*if(!emailRegex.test(monitorData.email)){
        alert('Please fill in the correct email address')
        return false;
      }*/

      $("#question-7-controls .next-button").prop('disabled', true).css('cursor', 'progress');
      $('body').css('cursor', 'progress');
      recommendProgram();
      //addType
     
      monitorData.recommendedModel = $("#recommendedModel").val();
      monitorData.totalFlowRate = $("#totalFlowRate").val();
      monitorData.waterInletTemperature = $("#waterInletTemperature").val();
      monitorData.GPM = $("#GPM").val();
      console.log( $("input[data-name='qtysize_showerhead']:checked"))
      var resultObj = {
        Flow_rate:  $("input[data-name='qtysize_showerhead']:checked + .solution-radio__label .solution-radio__label-text").text(),
        Number_faucets: $("input[data-name='number_faucets']:checked + .solution-radio__label .solution-radio__label-text").text(), 
        Fuel_type: $("input[data-name='fuel_type']:checked + .solution-radio__label .solution-image-radio__label-text").text(), 
        Door_size: $("input[data-name='door_size']:checked + .solution-image-radio__label .solution-image-radio__label-text").text(), 
        Heater_performance: $("input[data-name='heater_performance']:checked + .solution-radio__label .solution-radio__label-text").text(),
        State: monitorData.state,
        Email: monitorData.email
      }
      var th = "";
      var td = "";
      Object.keys(resultObj).forEach(key => {
        th += `<th>${key}</th>`;
        td += `<td>${resultObj[key]}</td>`;
      });

      var thDom = document.getElementById('th');
      var tdDom = document.getElementById('td');
      thDom.innerHTML = th;
      tdDom.innerHTML = td;

      monitorData.form_type = "contact"
      console.log(monitorData);
      $.ajax({
        type: 'POST',
        url: '/contact#form__solution-selector',
        data: monitorData,
        success: function(response) {
          console.log('Form data submitted:', monitorData);

        },
        error: function(error) {
          console.error('Error submitting form data:', error);
        }
      });
    });
    return false;
  }

  } catch(e) { console.error(e); }
})();
})();
